import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const AuthCallToAction = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <section className="py-20 bg-gradient-to-br from-primary/5 via-white to-primary/10">
      <div className="max-w-4xl mx-auto px-6 text-center">
        {/* Authentication Required Notice */}
        <div className="bg-white rounded-2xl shadow-xl p-8 lg:p-12 space-y-8">
          {/* Icon */}
          <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto">
            <Icon name="Lock" size={32} className="text-primary" />
          </div>

          {/* Content */}
          <div className="space-y-4">
            <h2 className="text-3xl lg:text-4xl font-bold text-foreground">
              Secure Access Required
            </h2>
            <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
              To access ClearEqual's powerful analytics and compliance tools, please sign in 
              with your authorized credentials or request a demonstration.
            </p>
          </div>

          {/* Authentication Options */}
          <div className="space-y-6">
            {/* Primary Actions */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button
                onClick={() => navigate('/login')}
                className="px-8 py-4 bg-accent text-white rounded-lg font-semibold hover:bg-accent/90 transition-smooth flex items-center justify-center space-x-2 min-w-[180px] shadow-sm"
              >
                <Icon name="LogIn" size={18} />
                <span>{t('landing.cta.signInNow')}</span>
              </button>
              <button
                onClick={() => navigate('/login')}
                className="px-8 py-4 border-2 border-primary text-primary rounded-lg font-semibold hover:bg-primary/5 transition-smooth flex items-center justify-center space-x-2 min-w-[180px]"
              >
                <Icon name="Calendar" size={18} />
                <span>{t('landing.cta.requestDemo')}</span>
              </button>
            </div>

            {/* Employee Access */}
            <div className="border-t border-border pt-6">
              <p className="text-sm text-muted-foreground mb-3">
                Employee? Access your pay information portal
              </p>
              <button
                onClick={() => navigate('/employee-login')}
                className="px-6 py-3 bg-muted text-foreground rounded-lg font-medium hover:bg-muted/80 transition-smooth flex items-center justify-center space-x-2 mx-auto"
              >
                <Icon name="User" size={16} />
                <span>{t('landing.cta.employeePortal')}</span>
              </button>
            </div>
          </div>

          {/* Security Notice */}
          <div className="bg-muted/50 rounded-lg p-4 space-y-3">
            <div className="flex items-center justify-center space-x-2">
              <Icon name="Shield" size={16} className="text-success" />
              <span className="text-sm font-medium text-foreground">{t('landing.cta.security')}</span>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 text-xs text-muted-foreground">
              <div className="flex items-center justify-center space-x-1">
                <Icon name="Lock" size={12} />
                <span>{t('landing.cta.securityE2E')}</span>
              </div>
              <div className="flex items-center justify-center space-x-1">
                <Icon name="CheckCircle" size={12} />
                <span>{t('landing.cta.securityMFA')}</span>
              </div>
              <div className="flex items-center justify-center space-x-1">
                <Icon name="Award" size={12} />
                <span>{t('landing.cta.securityGDPR')}</span>
              </div>
            </div>
          </div>

          {/* Help Information */}
          <div className="text-center space-y-2">
            <p className="text-sm text-muted-foreground">
              Need assistance accessing your account?
            </p>
            <div className="flex items-center justify-center space-x-6 text-sm">
              <button className="flex items-center space-x-1 text-primary hover:text-primary/80 transition-smooth">
                <Icon name="HelpCircle" size={14} />
                <span>{t('landing.cta.helpCenter')}</span>
              </button>
              <button className="flex items-center space-x-1 text-primary hover:text-primary/80 transition-smooth">
                <Icon name="Mail" size={14} />
                <span>support@clearequal.com</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AuthCallToAction;